import patternize from '@sdk/helpers/formatters/patternize';

import {
  CELLPHONE_NUMBER_FORMAT,
  CELLPHONE_NUMBER_REGEX,
} from './cellphone';

export default function cellphoneNumber(value = '') {
  if (['', undefined, null].includes(value)) {
    return false;
  }

  const formatted = patternize(value, {
    format: CELLPHONE_NUMBER_FORMAT,
  });

  if (CELLPHONE_NUMBER_REGEX.test(formatted)) {
    return false;
  }

  return true;
}

cellphoneNumber.message = function message(value, options = {}) {
  return options.message || 'não é um número válido';
};
